<template>
  <div class="header-wrapper" :class="{ scrolled: isScrolled }">
    <div class="header-container">
      <router-link to="/" class="logo">
        <!-- JIU&nbsp;MAO™ -->
        <el-image style="width: 178px;" :src="logoUrl" fit="contain" v-show="hiddenLogo"></el-image>
      </router-link>
      <div class="lang_area">
        <a class="lang_en" lang="en-us" :class="{ current: activeLang === 'en-us' }" @click="switchLang('en-us', $event)">EN</a>
        <i class="s_line">|</i>
        <a class="lang_ch" lang="zh-cn" :class="{ current: activeLang === 'zh-cn' }" @click="switchLang('zh-cn', $event)">简</a>
        <i class="s_line">|</i>
        <a class="lang_br" lang="pt-br" :class="{ current: activeLang === 'pt-br' }" @click="switchLang('pt-br', $event)">PT</a>
        <i class="s_line">|</i>
        <a class="lang_ru" lang="ru-ru" :class="{ current: activeLang === 'ru-ru' }" @click="switchLang('ru-ru', $event)">RU</a>
      </div>
    </div>
  </div>
</template>

<script>
import logoImg from '@/assets/logo.png';
import logoImg2 from '@/assets/logo2.png';
export default {
  name: 'AppHeader',
  props: {
    isScrolled: {
      required: false,
      type: Boolean,
      default: false
    },
    hiddenLogo: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeLang: ''
    }
  },
  mounted() {
    const savedLang = localStorage.getItem('browserSign');
    this.activeLang = savedLang || 'en-us';
  },
  methods: {
    switchLang(lang, e) {
      localStorage.setItem('browserSign', lang);
      this.activeLang = lang;
      this.$parent.refreshPage();
    }
  },
  computed: {
    logoUrl() {
      return this.isScrolled?logoImg:logoImg2
    }
  }
}
</script>

<style lang="scss">

// 导航栏样式
.header-wrapper {
  transition: background-color 0.3s ease-in-out;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease; // 更平滑的过渡
  z-index: 99; // 提高层级确保覆盖
  box-sizing: border-box;
  width: 100%;
  padding: 0 5%; // 使用百分比响应式边距
  background-color: rgba(211, 227, 253, 0); // 更深的半透明背景
  backdrop-filter: blur(5px); // 毛玻璃效果
  border-bottom: 1px solid rgba(255, 255, 255, 0.1); // 底部细边框
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif; // 更好的字体
  top: 0%;
  left: 0%;
  position: fixed;

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center; // 垂直居中
    height: 100%;
    width: 100%;
    max-width: 1440px;

    .logo {
      font-size: 22px; // 增大logo
      font-weight: 600;
      color: #fff;
      display: flex;
      align-items: center;
      
      img {
        height: 32px; // 如果使用图片logo
        margin-right: 10px;
      }
      
      &:hover {
        opacity: 0.9;
      }
    }
    
    .lang_area {
      color: #606266;
      // font-weight: bold;
      .current {
        color: #000;
      }
      .s_line {
        margin: 0px 8px;
      }
    }

    ::v-deep .el-tabs__item {
      color: #fff;// 深度选择器
      font-weight: bolder;
      
      &.is-active {
        color: #409EFF !important;
      }
      
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.header-wrapper.scrolled {
  background-color: rgba(211, 227, 253, 0.85);
}
</style>